module.exports = __webpack_public_path__ + "img/expert_name_bg.b416495.png";